import React from "react";

import { ArrowRightCircleFill } from "react-bootstrap-icons";

export default function LayananKami(props) {
  return (
    <>
      <div
        className="mx-3 py-lg-5 my-lg-3 text-bg-light rounded-3 shadow-lg"
        style={{ width: "20rem" }}
      >
        <div className="cardImageLayananKami">
          <img
            src={props.image}
            alt="imageCardLayananKami"
            height={"90%"}
            width={"65%"}
            // className="img-fluid"
          />
        </div>
        <div className="card-body h-50">
          <h4 className="card-title text-center py-3 fw-bold">{props.title}</h4>
          <p className="card-text descriptionLayananKami px-lg-3">
            {props.description.substring(0, 250) + "..."}
          </p>
          <a
            href={props.link}
            className="text-success fs-5 px-lg-3 text-decoration-none"
          >
            Pelajari lebih lanjut <ArrowRightCircleFill />
          </a>
        </div>
      </div>
    </>
  );
}
